// test1502
(1502 && 0);
